/**
 * @typedef {import('react-reconciler').Fiber} Fiber
 * @typedef {import('react-reconciler').Source} Source
 */

/**
 * @param {Fiber} instance
 */
export function getSourceForInstance(_ref) {
  var _debugSource = _ref._debugSource;
  if (!_debugSource) return;
  var _debugSource$columnNu = _debugSource.columnNumber,
    columnNumber = _debugSource$columnNu === void 0 ? 1 : _debugSource$columnNu,
    fileName = _debugSource.fileName,
    _debugSource$lineNumb = _debugSource.lineNumber,
    lineNumber = _debugSource$lineNumb === void 0 ? 1 : _debugSource$lineNumb;
  return {
    columnNumber: columnNumber,
    fileName: fileName,
    lineNumber: lineNumber
  };
}